/** 应用案例页文案 — 应用场景产品矩阵 */
const SCENE_KEYS_EN = {
  scenePhoneCase: "Phone Case",
  sceneAcrylic: "Acrylic",
  sceneGlass: "Glass",
  sceneWood: "Wood",
  scenePvc: "PVC",
  sceneAbs: "ABS",
  sceneLeather: "Leather",
  sceneMetal: "Metal",
  sceneGiftBox: "Gift Box",
  sceneLuggage: "Luggage",
  sceneSignage: "Signage",
  sceneStone: "Stone",
  sceneThermos: "Thermos",
  sceneMug: "Mug",
  sceneGlassCup: "Glass Cup",
  sceneWineBottle: "Wine Bottle",
  scenePerfume: "Perfume",
  sceneCosmetic: "Cosmetic",
  sceneWaterBottle: "Water Bottle",
  sceneSportBottle: "Sports Bottle",
  sceneVacuumPot: "Vacuum Pot",
  sceneMilkTea: "Tea Cup",
  sceneHelmet: "Helmet",
  scenePackBox: "Pack Box",
  sceneCeramic: "Ceramic",
  sceneTshirt: "T-Shirt",
  sceneHoodie: "Hoodie",
  sceneCap: "Cap",
  sceneJeans: "Jeans",
  sceneTote: "Tote Bag",
  sceneShoes: "Shoes",
  sceneKidsWear: "Kids Wear",
  sceneWorkWear: "Workwear",
  sceneSportWear: "Sportswear",
  scenePillow: "Pillow",
  sceneDenim: "Denim",
  sceneCanvas: "Canvas",
  sceneCotton: "Cotton",
  scenePolo: "Polo Shirt",
  sceneEcoBag: "Eco Bag",
};

export const caseTranslations = {
  zh: {
    casesHeroTitle: "应用场景",
    casesHeroLead: "适用于多种材质与定制场景，满足个性化定制、小批量生产与工业应用需求",
    casesEquipmentTitle: "设备类型",
    casesSceneTitleUv: "UV平板打印机可以打印哪些产品？",
    casesSceneTitleCylinder: "圆柱体打印机可以打印哪些产品？",
    casesSceneTitleCrystal: "水晶标打印机可以打印哪些产品？",
    casesSceneTitleDtf: "DTF打印机可以打印哪些产品？",
    casesSceneTitleDtg: "DTG打印机可以打印哪些产品？",
    casesCtaTitle: "发现新的打印生意机会",
    casesCtaDesc: "告诉我们您想打印的产品，我们将为您匹配适合的数字打印方案。",
    casesCtaButton: "获取打印方案",
    casesEmpty: "暂无该设备的应用场景",
    casesIndustryNav: "行业分类",
    backToTop: "回到顶部",
    casesDetailTitle: "打印效果",
    casesVariantsIntro: "可打印多种类型",
    casesVariantsMore: "等等",
    casesVariantsHint: "告诉我们您要打印的产品材质与数量，获取专属打印方案。",
    casesCardTagline: "个性化定制",
    casesCardPitch: "高精度彩色打印",
    casesPrintEffect: "打印效果",
    casesAppVideo: "应用视频",
    casesVideoPlaceholder: "视频即将上线",
    scenePhoneCase: "手机壳",
    sceneAcrylic: "亚克力",
    sceneGlass: "玻璃",
    sceneWood: "木板",
    scenePvc: "PVC板",
    sceneAbs: "ABS",
    sceneLeather: "皮革",
    sceneMetal: "金属",
    sceneGiftBox: "礼盒",
    sceneLuggage: "行李箱",
    sceneSignage: "标牌",
    sceneStone: "石材",
    sceneThermos: "保温杯",
    sceneMug: "马克杯",
    sceneGlassCup: "玻璃杯",
    sceneWineBottle: "酒瓶",
    scenePerfume: "香水瓶",
    sceneCosmetic: "化妆品瓶",
    sceneWaterBottle: "矿泉水瓶",
    sceneSportBottle: "运动水壶",
    sceneVacuumPot: "保温壶",
    sceneMilkTea: "奶茶杯",
    sceneHelmet: "头盔",
    scenePackBox: "包装盒",
    sceneCeramic: "陶瓷",
    sceneTshirt: "T恤",
    sceneHoodie: "卫衣",
    sceneCap: "帽子",
    sceneJeans: "牛仔裤",
    sceneTote: "帆布袋",
    sceneShoes: "鞋子",
    sceneKidsWear: "童装",
    sceneWorkWear: "工服",
    sceneSportWear: "运动服",
    scenePillow: "抱枕",
    sceneDenim: "牛仔布",
    sceneCanvas: "帆布",
    sceneCotton: "棉布",
    scenePolo: "POLO衫",
    sceneEcoBag: "环保袋",
  },
  en: {
    casesHeroTitle: "Application Scenarios",
    casesHeroLead: "See what products digital printing can create value for",
    casesEquipmentTitle: "Equipment",
    casesSceneTitleUv: "What can a UV flatbed printer print?",
    casesSceneTitleCylinder: "What can a cylindrical printer print?",
    casesSceneTitleCrystal: "What can a crystal label printer print?",
    casesSceneTitleDtf: "What can a DTF printer print?",
    casesSceneTitleDtg: "What can a DTG printer print?",
    casesCtaTitle: "Discover new print business opportunities",
    casesCtaDesc:
      "Tell us what you want to print and we will match a suitable digital printing solution.",
    casesCtaButton: "Get Printing Solution",
    casesEmpty: "No application scenes for this equipment yet.",
    casesIndustryNav: "Industries",
    backToTop: "Back to top",
    casesDetailTitle: "Print Result",
    casesVariantsIntro: "Printable types",
    casesVariantsMore: "etc.",
    casesVariantsHint: "Tell us your material and quantity to get a tailored printing solution.",
    casesCardTagline: "Personalization",
    casesCardPitch: "High-precision color printing",
    casesPrintEffect: "Print Result",
    casesAppVideo: "Application Video",
    casesVideoPlaceholder: "Video coming soon",
    scenePhoneCase: "Phone Case",
    sceneAcrylic: "Acrylic",
    sceneGlass: "Glass",
    sceneWood: "Wood",
    scenePvc: "PVC",
    sceneAbs: "ABS",
    sceneLeather: "Leather",
    sceneMetal: "Metal",
    sceneGiftBox: "Gift Box",
    sceneLuggage: "Luggage",
    sceneSignage: "Signage",
    sceneStone: "Stone",
    sceneThermos: "Thermos",
    sceneMug: "Mug",
    sceneGlassCup: "Glass Cup",
    sceneWineBottle: "Wine Bottle",
    scenePerfume: "Perfume",
    sceneCosmetic: "Cosmetic",
    sceneWaterBottle: "Water Bottle",
    sceneSportBottle: "Sports Bottle",
    sceneVacuumPot: "Vacuum Pot",
    sceneMilkTea: "Tea Cup",
    sceneHelmet: "Helmet",
    scenePackBox: "Pack Box",
    sceneCeramic: "Ceramic",
    sceneTshirt: "T-Shirt",
    sceneHoodie: "Hoodie",
    sceneCap: "Cap",
    sceneJeans: "Jeans",
    sceneTote: "Tote Bag",
    sceneShoes: "Shoes",
    sceneKidsWear: "Kids Wear",
    sceneWorkWear: "Workwear",
    sceneSportWear: "Sportswear",
    scenePillow: "Pillow",
    sceneDenim: "Denim",
    sceneCanvas: "Canvas",
    sceneCotton: "Cotton",
    scenePolo: "Polo Shirt",
    sceneEcoBag: "Eco Bag",
  },
  de: {
    casesHeroTitle: "Anwendungsszenarien",
    casesHeroLead: "Entdecken Sie, für welche Produkte der Digitaldruck Mehrwert schafft",
    casesEquipmentTitle: "Geräte",
    casesSceneTitleUv: "Was kann ein UV-Flachbettdrucker drucken?",
    casesSceneTitleCylinder: "Was kann ein Zylinderdrucker drucken?",
    casesSceneTitleCrystal: "Was kann ein Kristalletikettendrucker drucken?",
    casesSceneTitleDtf: "Was kann ein DTF-Drucker drucken?",
    casesSceneTitleDtg: "Was kann ein DTG-Drucker drucken?",
    casesCtaTitle: "Entdecken Sie neue Druckgeschäftschancen",
    casesCtaDesc:
      "Sagen Sie uns, was Sie drucken möchten – wir finden die passende Digitaldrucklösung.",
    casesCtaButton: "Drucklösung erhalten",
    casesEmpty: "Noch keine Anwendungsszenarien für dieses Gerät.",
    casesIndustryNav: "Branchen",
    backToTop: "Nach oben",
    casesDetailTitle: "Druckergebnis",
    casesVariantsIntro: "Druckbare Typen",
    casesVariantsMore: "usw.",
    casesVariantsHint: "Nennen Sie uns Material und Menge für eine maßgeschneiderte Drucklösung.",
    casesCardTagline: "Personalisierung",
    casesCardPitch: "Hochpräziser Farbdruck",
    casesPrintEffect: "Druckergebnis",
    casesAppVideo: "Anwendungsvideo",
    casesVideoPlaceholder: "Video folgt in Kürze",
    ...SCENE_KEYS_EN,
  },
  pt: {
    casesHeroTitle: "Cenários de aplicação",
    casesHeroLead: "Veja para quais produtos a impressão digital pode criar valor",
    casesEquipmentTitle: "Equipamentos",
    casesSceneTitleUv: "O que uma impressora UV de mesa plana pode imprimir?",
    casesSceneTitleCylinder: "O que uma impressora cilíndrica pode imprimir?",
    casesSceneTitleCrystal: "O que uma impressora de etiquetas de cristal pode imprimir?",
    casesSceneTitleDtf: "O que uma impressora DTF pode imprimir?",
    casesSceneTitleDtg: "O que uma impressora DTG pode imprimir?",
    casesCtaTitle: "Descubra novas oportunidades de negócio em impressão",
    casesCtaDesc:
      "Diga-nos o que deseja imprimir e encontraremos a solução de impressão digital adequada.",
    casesCtaButton: "Obter solução de impressão",
    casesEmpty: "Ainda não há cenários de aplicação para este equipamento.",
    casesIndustryNav: "Indústrias",
    backToTop: "Voltar ao topo",
    casesDetailTitle: "Resultado da impressão",
    casesVariantsIntro: "Tipos imprimíveis",
    casesVariantsMore: "etc.",
    casesVariantsHint: "Informe o material e a quantidade para obter uma solução de impressão sob medida.",
    casesCardTagline: "Personalização",
    casesCardPitch: "Impressão colorida de alta precisão",
    casesPrintEffect: "Resultado da impressão",
    casesAppVideo: "Vídeo de aplicação",
    casesVideoPlaceholder: "Vídeo em breve",
    ...SCENE_KEYS_EN,
  },
  es: {
    casesHeroTitle: "Escenarios de aplicación",
    casesHeroLead: "Descubra para qué productos la impresión digital puede crear valor",
    casesEquipmentTitle: "Equipos",
    casesSceneTitleUv: "¿Qué puede imprimir una impresora UV de cama plana?",
    casesSceneTitleCylinder: "¿Qué puede imprimir una impresora cilíndrica?",
    casesSceneTitleCrystal: "¿Qué puede imprimir una impresora de etiquetas de cristal?",
    casesSceneTitleDtf: "¿Qué puede imprimir una impresora DTF?",
    casesSceneTitleDtg: "¿Qué puede imprimir una impresora DTG?",
    casesCtaTitle: "Descubra nuevas oportunidades de negocio en impresión",
    casesCtaDesc:
      "Cuéntenos qué desea imprimir y le ofreceremos una solución de impresión digital adecuada.",
    casesCtaButton: "Obtener solución de impresión",
    casesEmpty: "Aún no hay escenarios de aplicación para este equipo.",
    casesIndustryNav: "Industrias",
    backToTop: "Volver arriba",
    casesDetailTitle: "Resultado de impresión",
    casesVariantsIntro: "Tipos imprimibles",
    casesVariantsMore: "etc.",
    casesVariantsHint: "Indíquenos el material y la cantidad para obtener una solución de impresión a medida.",
    casesCardTagline: "Personalización",
    casesCardPitch: "Impresión a color de alta precisión",
    casesPrintEffect: "Resultado de impresión",
    casesAppVideo: "Vídeo de aplicación",
    casesVideoPlaceholder: "Vídeo próximamente",
    ...SCENE_KEYS_EN,
  },
  fr: {
    casesHeroTitle: "Scénarios d'application",
    casesHeroLead: "Découvrez pour quels produits l'impression numérique crée de la valeur",
    casesEquipmentTitle: "Équipements",
    casesSceneTitleUv: "Que peut imprimer une imprimante UV à plat ?",
    casesSceneTitleCylinder: "Que peut imprimer une imprimante cylindrique ?",
    casesSceneTitleCrystal: "Que peut imprimer une imprimante d'étiquettes cristal ?",
    casesSceneTitleDtf: "Que peut imprimer une imprimante DTF ?",
    casesSceneTitleDtg: "Que peut imprimer une imprimante DTG ?",
    casesCtaTitle: "Découvrez de nouvelles opportunités commerciales d'impression",
    casesCtaDesc:
      "Dites-nous ce que vous souhaitez imprimer et nous vous proposerons une solution d'impression numérique adaptée.",
    casesCtaButton: "Obtenir une solution d'impression",
    casesEmpty: "Aucun scénario d'application pour cet équipement pour le moment.",
    casesIndustryNav: "Secteurs",
    backToTop: "Retour en haut",
    casesDetailTitle: "Résultat d'impression",
    casesVariantsIntro: "Types imprimables",
    casesVariantsMore: "etc.",
    casesVariantsHint: "Indiquez-nous le matériau et la quantité pour une solution d'impression sur mesure.",
    casesCardTagline: "Personnalisation",
    casesCardPitch: "Impression couleur haute précision",
    casesPrintEffect: "Résultat d'impression",
    casesAppVideo: "Vidéo d'application",
    casesVideoPlaceholder: "Vidéo bientôt disponible",
    ...SCENE_KEYS_EN,
  },
  it: {
    casesHeroTitle: "Scenari applicativi",
    casesHeroLead: "Scopri per quali prodotti la stampa digitale può creare valore",
    casesEquipmentTitle: "Attrezzature",
    casesSceneTitleUv: "Cosa può stampare una stampante UV a piano?",
    casesSceneTitleCylinder: "Cosa può stampare una stampante cilindrica?",
    casesSceneTitleCrystal: "Cosa può stampare una stampante per etichette cristallo?",
    casesSceneTitleDtf: "Cosa può stampare una stampante DTF?",
    casesSceneTitleDtg: "Cosa può stampare una stampante DTG?",
    casesCtaTitle: "Scopri nuove opportunità di business nella stampa",
    casesCtaDesc:
      "Dicci cosa vuoi stampare e ti abbineremo la soluzione di stampa digitale più adatta.",
    casesCtaButton: "Ottieni soluzione di stampa",
    casesEmpty: "Nessuno scenario applicativo per questa attrezzatura al momento.",
    casesIndustryNav: "Settori",
    backToTop: "Torna su",
    casesDetailTitle: "Risultato di stampa",
    casesVariantsIntro: "Tipi stampabili",
    casesVariantsMore: "ecc.",
    casesVariantsHint: "Indicaci materiale e quantità per ottenere una soluzione di stampa su misura.",
    casesCardTagline: "Personalizzazione",
    casesCardPitch: "Stampa a colori ad alta precisione",
    casesPrintEffect: "Risultato di stampa",
    casesAppVideo: "Video applicativo",
    casesVideoPlaceholder: "Video in arrivo",
    ...SCENE_KEYS_EN,
  },
  hi: {
    casesHeroTitle: "अनुप्रयोग परिदृश्य",
    casesHeroLead: "देखें कि डिजिटल प्रिंटिंग किन उत्पादों के लिए मूल्य बना सकती है",
    casesEquipmentTitle: "उपकरण",
    casesSceneTitleUv: "यूवी फ्लैटबेड प्रिंटर क्या प्रिंट कर सकता है?",
    casesSceneTitleCylinder: "सिलिंडर प्रिंटर क्या प्रिंट कर सकता है?",
    casesSceneTitleCrystal: "क्रिस्टल लेबल प्रिंटर क्या प्रिंट कर सकता है?",
    casesSceneTitleDtf: "डीटीएफ प्रिंटर क्या प्रिंट कर सकता है?",
    casesSceneTitleDtg: "डीटीजी प्रिंटर क्या प्रिंट कर सकता है?",
    casesCtaTitle: "प्रिंटिंग व्यवसाय के नए अवसर खोजें",
    casesCtaDesc:
      "बताएं कि आप क्या प्रिंट करना चाहते हैं, हम उपयुक्त डिजिटल प्रिंटिंग समाधान सुझाएंगे।",
    casesCtaButton: "प्रिंटिंग समाधान प्राप्त करें",
    casesEmpty: "इस उपकरण के लिए अभी कोई अनुप्रयोग परिदृश्य नहीं है।",
    casesIndustryNav: "उद्योग",
    backToTop: "ऊपर जाएँ",
    casesDetailTitle: "प्रिंट परिणाम",
    casesVariantsIntro: "प्रिंट योग्य प्रकार",
    casesVariantsMore: "आदि",
    casesVariantsHint: "अनुकूलित प्रिंटिंग समाधान के लिए सामग्री और मात्रा बताएं।",
    casesCardTagline: "व्यक्तिगतकरण",
    casesCardPitch: "उच्च-सटीक रंगीन प्रिंटिंग",
    casesPrintEffect: "प्रिंट परिणाम",
    casesAppVideo: "अनुप्रयोग वीडियो",
    casesVideoPlaceholder: "वीडियो जल्द आ रहा है",
    ...SCENE_KEYS_EN,
  },
  ru: {
    casesHeroTitle: "Сценарии применения",
    casesHeroLead: "Узнайте, для каких изделий цифровая печать создаёт ценность",
    casesEquipmentTitle: "Оборудование",
    casesSceneTitleUv: "Что может печатать УФ-планшетный принтер?",
    casesSceneTitleCylinder: "Что может печатать цилиндрический принтер?",
    casesSceneTitleCrystal: "Что может печатать принтер кристальных этикеток?",
    casesSceneTitleDtf: "Что может печатать DTF-принтер?",
    casesSceneTitleDtg: "Что может печатать DTG-принтер?",
    casesCtaTitle: "Откройте новые возможности печатного бизнеса",
    casesCtaDesc:
      "Расскажите, что хотите печатать — мы подберём подходящее решение цифровой печати.",
    casesCtaButton: "Получить решение по печати",
    casesEmpty: "Пока нет сценариев применения для этого оборудования.",
    casesIndustryNav: "Отрасли",
    backToTop: "Наверх",
    casesDetailTitle: "Результат печати",
    casesVariantsIntro: "Печатаемые типы",
    casesVariantsMore: "и т. д.",
    casesVariantsHint: "Укажите материал и тираж — получите индивидуальное решение по печати.",
    casesCardTagline: "Персонализация",
    casesCardPitch: "Высокоточная цветная печать",
    casesPrintEffect: "Результат печати",
    casesAppVideo: "Видео применения",
    casesVideoPlaceholder: "Видео скоро появится",
    ...SCENE_KEYS_EN,
  },
  ko: {
    casesHeroTitle: "적용 시나리오",
    casesHeroLead: "디지털 인쇄가 어떤 제품에 가치를 창출하는지 확인하세요",
    casesEquipmentTitle: "장비",
    casesSceneTitleUv: "UV 평판 프린터로 무엇을 인쇄할 수 있나요?",
    casesSceneTitleCylinder: "원통형 프린터로 무엇을 인쇄할 수 있나요?",
    casesSceneTitleCrystal: "크리스탈 라벨 프린터로 무엇을 인쇄할 수 있나요?",
    casesSceneTitleDtf: "DTF 프린터로 무엇을 인쇄할 수 있나요?",
    casesSceneTitleDtg: "DTG 프린터로 무엇을 인쇄할 수 있나요?",
    casesCtaTitle: "새로운 인쇄 비즈니스 기회를 발견하세요",
    casesCtaDesc:
      "인쇄하고 싶은 제품을 알려주시면 적합한 디지털 인쇄 솔루션을 매칭해 드립니다.",
    casesCtaButton: "인쇄 솔루션 받기",
    casesEmpty: "이 장비에 대한 적용 시나리오가 아직 없습니다.",
    casesIndustryNav: "산업",
    backToTop: "맨 위로",
    casesDetailTitle: "인쇄 결과",
    casesVariantsIntro: "인쇄 가능 유형",
    casesVariantsMore: "등",
    casesVariantsHint: "맞춤 인쇄 솔루션을 위해 소재와 수량을 알려주세요.",
    casesCardTagline: "개인 맞춤",
    casesCardPitch: "고정밀 컬러 인쇄",
    casesPrintEffect: "인쇄 결과",
    casesAppVideo: "적용 영상",
    casesVideoPlaceholder: "영상 곧 공개",
    ...SCENE_KEYS_EN,
  },
  ja: {
    casesHeroTitle: "活用シーン",
    casesHeroLead: "デジタル印刷がどのような製品に価値を生み出すかご覧ください",
    casesEquipmentTitle: "設備",
    casesSceneTitleUv: "UVフラットベッドプリンターで何が印刷できますか？",
    casesSceneTitleCylinder: "円筒プリンターで何が印刷できますか？",
    casesSceneTitleCrystal: "クリスタルラベルプリンターで何が印刷できますか？",
    casesSceneTitleDtf: "DTFプリンターで何が印刷できますか？",
    casesSceneTitleDtg: "DTGプリンターで何が印刷できますか？",
    casesCtaTitle: "新しい印刷ビジネスの機会を見つけましょう",
    casesCtaDesc:
      "印刷したい製品をお知らせください。最適なデジタル印刷ソリューションをご提案します。",
    casesCtaButton: "印刷ソリューションを取得",
    casesEmpty: "この設備の活用シーンはまだありません。",
    casesIndustryNav: "業種",
    backToTop: "ページ上部へ",
    casesDetailTitle: "印刷結果",
    casesVariantsIntro: "印刷可能なタイプ",
    casesVariantsMore: "など",
    casesVariantsHint: "素材と数量をお知らせいただければ、専用の印刷ソリューションをご提案します。",
    casesCardTagline: "パーソナライズ",
    casesCardPitch: "高精度カラー印刷",
    casesPrintEffect: "印刷結果",
    casesAppVideo: "活用動画",
    casesVideoPlaceholder: "動画近日公開",
    ...SCENE_KEYS_EN,
  },
  th: {
    casesHeroTitle: "สถานการณ์การใช้งาน",
    casesHeroLead: "ดูว่าการพิมพ์ดิจิทัลสร้างมูลค่าให้ผลิตภัณฑ์ใดได้บ้าง",
    casesEquipmentTitle: "อุปกรณ์",
    casesSceneTitleUv: "เครื่องพิมพ์ UV แบบแท่นเรียบพิมพ์อะไรได้บ้าง?",
    casesSceneTitleCylinder: "เครื่องพิมพ์ทรงกระบอกพิมพ์อะไรได้บ้าง?",
    casesSceneTitleCrystal: "เครื่องพิมพ์ฉลากคริสตัลพิมพ์อะไรได้บ้าง?",
    casesSceneTitleDtf: "เครื่องพิมพ์ DTF พิมพ์อะไรได้บ้าง?",
    casesSceneTitleDtg: "เครื่องพิมพ์ DTG พิมพ์อะไรได้บ้าง?",
    casesCtaTitle: "ค้นพบโอกาสทางธุรกิจการพิมพ์ใหม่",
    casesCtaDesc:
      "บอกเราว่าคุณต้องการพิมพ์อะไร เราจะจับคู่โซลูชันการพิมพ์ดิจิทัลที่เหมาะสม",
    casesCtaButton: "รับโซลูชันการพิมพ์",
    casesEmpty: "ยังไม่มีสถานการณ์การใช้งานสำหรับอุปกรณ์นี้",
    casesIndustryNav: "อุตสาหกรรม",
    backToTop: "กลับขึ้นด้านบน",
    casesDetailTitle: "ผลงานพิมพ์",
    casesVariantsIntro: "ประเภทที่พิมพ์ได้",
    casesVariantsMore: "ฯลฯ",
    casesVariantsHint: "บอกวัสดุและปริมาณเพื่อรับโซลูชันการพิมพ์ที่เหมาะสม",
    casesCardTagline: "การปรับแต่งเฉพาะบุคคล",
    casesCardPitch: "การพิมพ์สีความละเอียดสูง",
    casesPrintEffect: "ผลงานพิมพ์",
    casesAppVideo: "วิดีโอการใช้งาน",
    casesVideoPlaceholder: "วิดีโอเร็วๆ นี้",
    ...SCENE_KEYS_EN,
  },
  tr: {
    casesHeroTitle: "Uygulama Senaryoları",
    casesHeroLead: "Dijital baskının hangi ürünler için değer yaratabileceğini görün",
    casesEquipmentTitle: "Ekipman",
    casesSceneTitleUv: "UV flatbed yazıcı ne yazdırabilir?",
    casesSceneTitleCylinder: "Silindirik yazıcı ne yazdırabilir?",
    casesSceneTitleCrystal: "Kristal etiket yazıcısı ne yazdırabilir?",
    casesSceneTitleDtf: "DTF yazıcı ne yazdırabilir?",
    casesSceneTitleDtg: "DTG yazıcı ne yazdırabilir?",
    casesCtaTitle: "Yeni baskı iş fırsatlarını keşfedin",
    casesCtaDesc:
      "Ne yazdırmak istediğinizi söyleyin, size uygun dijital baskı çözümünü eşleştirelim.",
    casesCtaButton: "Baskı Çözümü Alın",
    casesEmpty: "Bu ekipman için henüz uygulama senaryosu yok.",
    casesIndustryNav: "Sektörler",
    backToTop: "Yukarı çık",
    casesDetailTitle: "Baskı Sonucu",
    casesVariantsIntro: "Yazdırılabilir türler",
    casesVariantsMore: "vb.",
    casesVariantsHint: "Özel baskı çözümü için malzeme ve miktarınızı bize bildirin.",
    casesCardTagline: "Kişiselleştirme",
    casesCardPitch: "Yüksek hassasiyetli renkli baskı",
    casesPrintEffect: "Baskı Sonucu",
    casesAppVideo: "Uygulama Videosu",
    casesVideoPlaceholder: "Video yakında",
    ...SCENE_KEYS_EN,
  },
  vi: {
    casesHeroTitle: "Kịch bản ứng dụng",
    casesHeroLead: "Xem in kỹ thuật số có thể tạo giá trị cho những sản phẩm nào",
    casesEquipmentTitle: "Thiết bị",
    casesSceneTitleUv: "Máy in UV phẳng có thể in những gì?",
    casesSceneTitleCylinder: "Máy in trụ tròn có thể in những gì?",
    casesSceneTitleCrystal: "Máy in nhãn pha lê có thể in những gì?",
    casesSceneTitleDtf: "Máy in DTF có thể in những gì?",
    casesSceneTitleDtg: "Máy in DTG có thể in những gì?",
    casesCtaTitle: "Khám phá cơ hội kinh doanh in ấn mới",
    casesCtaDesc:
      "Cho chúng tôi biết bạn muốn in gì, chúng tôi sẽ ghép giải pháp in kỹ thuật số phù hợp.",
    casesCtaButton: "Nhận giải pháp in ấn",
    casesEmpty: "Chưa có kịch bản ứng dụng cho thiết bị này.",
    casesIndustryNav: "Ngành nghề",
    backToTop: "Về đầu trang",
    casesDetailTitle: "Kết quả in",
    casesVariantsIntro: "Loại có thể in",
    casesVariantsMore: "v.v.",
    casesVariantsHint: "Cho chúng tôi biết chất liệu và số lượng để nhận giải pháp in phù hợp.",
    casesCardTagline: "Cá nhân hóa",
    casesCardPitch: "In màu độ chính xác cao",
    casesPrintEffect: "Kết quả in",
    casesAppVideo: "Video ứng dụng",
    casesVideoPlaceholder: "Video sắp ra mắt",
    ...SCENE_KEYS_EN,
  },
  nl: {
    casesHeroTitle: "Toepassingsscenario's",
    casesHeroLead: "Ontdek voor welke producten digitaal printen waarde kan creëren",
    casesEquipmentTitle: "Apparatuur",
    casesSceneTitleUv: "Wat kan een UV-flatbedprinter printen?",
    casesSceneTitleCylinder: "Wat kan een cilindrische printer printen?",
    casesSceneTitleCrystal: "Wat kan een kristalletikettenprinter printen?",
    casesSceneTitleDtf: "Wat kan een DTF-printer printen?",
    casesSceneTitleDtg: "Wat kan een DTG-printer printen?",
    casesCtaTitle: "Ontdek nieuwe printzakelijke kansen",
    casesCtaDesc:
      "Vertel ons wat u wilt printen en wij matchen een passende digitale printoplossing.",
    casesCtaButton: "Printoplossing verkrijgen",
    casesEmpty: "Nog geen toepassingsscenario's voor deze apparatuur.",
    casesIndustryNav: "Branche",
    backToTop: "Terug naar boven",
    casesDetailTitle: "Printresultaat",
    casesVariantsIntro: "Printbare typen",
    casesVariantsMore: "enz.",
    casesVariantsHint: "Vertel ons uw materiaal en aantal voor een op maat gemaakte printoplossing.",
    casesCardTagline: "Personalisatie",
    casesCardPitch: "Hoogprecieze kleurendruk",
    casesPrintEffect: "Printresultaat",
    casesAppVideo: "Toepassingsvideo",
    casesVideoPlaceholder: "Video binnenkort beschikbaar",
    ...SCENE_KEYS_EN,
  },
  id: {
    casesHeroTitle: "Skenario Aplikasi",
    casesHeroLead: "Lihat produk mana yang dapat diberi nilai oleh pencetakan digital",
    casesEquipmentTitle: "Peralatan",
    casesSceneTitleUv: "Apa yang dapat dicetak printer UV flatbed?",
    casesSceneTitleCylinder: "Apa yang dapat dicetak printer silinder?",
    casesSceneTitleCrystal: "Apa yang dapat dicetak printer label kristal?",
    casesSceneTitleDtf: "Apa yang dapat dicetak printer DTF?",
    casesSceneTitleDtg: "Apa yang dapat dicetak printer DTG?",
    casesCtaTitle: "Temukan peluang bisnis cetak baru",
    casesCtaDesc:
      "Beritahu kami apa yang ingin Anda cetak, kami akan mencocokkan solusi pencetakan digital yang sesuai.",
    casesCtaButton: "Dapatkan Solusi Cetak",
    casesEmpty: "Belum ada skenario aplikasi untuk peralatan ini.",
    casesIndustryNav: "Industri",
    backToTop: "Kembali ke atas",
    casesDetailTitle: "Hasil Cetak",
    casesVariantsIntro: "Jenis yang dapat dicetak",
    casesVariantsMore: "dll.",
    casesVariantsHint: "Beritahu kami material dan jumlah untuk mendapatkan solusi cetak yang disesuaikan.",
    casesCardTagline: "Personalisasi",
    casesCardPitch: "Pencetakan warna berpresisi tinggi",
    casesPrintEffect: "Hasil Cetak",
    casesAppVideo: "Video Aplikasi",
    casesVideoPlaceholder: "Video segera hadir",
    ...SCENE_KEYS_EN,
  },
  ar: {
    casesHeroTitle: "سيناريوهات التطبيق",
    casesHeroLead: "اطّلع على المنتجات التي يمكن للطباعة الرقمية أن تُضيف لها قيمة",
    casesEquipmentTitle: "المعدات",
    casesSceneTitleUv: "ماذا يمكن لطابعة UV المسطحة أن تطبع؟",
    casesSceneTitleCylinder: "ماذا يمكن للطابعة الأسطوانية أن تطبع؟",
    casesSceneTitleCrystal: "ماذا يمكن لطابعة ملصقات الكريستال أن تطبع؟",
    casesSceneTitleDtf: "ماذا يمكن لطابعة DTF أن تطبع؟",
    casesSceneTitleDtg: "ماذا يمكن لطابعة DTG أن تطبع؟",
    casesCtaTitle: "اكتشف فرص أعمال طباعة جديدة",
    casesCtaDesc:
      "أخبرنا بما تريد طباعته وسنطابق لك حل الطباعة الرقمية المناسب.",
    casesCtaButton: "احصل على حل الطباعة",
    casesEmpty: "لا توجد سيناريوهات تطبيق لهذه المعدات بعد.",
    casesIndustryNav: "الصناعات",
    backToTop: "العودة إلى الأعلى",
    casesDetailTitle: "نتيجة الطباعة",
    casesVariantsIntro: "الأنواع القابلة للطباعة",
    casesVariantsMore: "إلخ.",
    casesVariantsHint: "أخبرنا بالمادة والكمية للحصول على حل طباعة مخصص.",
    casesCardTagline: "التخصيص",
    casesCardPitch: "طباعة ملونة عالية الدقة",
    casesPrintEffect: "نتيجة الطباعة",
    casesAppVideo: "فيديو التطبيق",
    casesVideoPlaceholder: "الفيديو قريبًا",
    ...SCENE_KEYS_EN,
  },
  pl: {
    casesHeroTitle: "Scenariusze zastosowań",
    casesHeroLead: "Zobacz, dla jakich produktów druk cyfrowy może tworzyć wartość",
    casesEquipmentTitle: "Sprzęt",
    casesSceneTitleUv: "Co może drukować drukarka UV flatbed?",
    casesSceneTitleCylinder: "Co może drukować drukarka cylindryczna?",
    casesSceneTitleCrystal: "Co może drukować drukarka etykiet kryształowych?",
    casesSceneTitleDtf: "Co może drukować drukarka DTF?",
    casesSceneTitleDtg: "Co może drukować drukarka DTG?",
    casesCtaTitle: "Odkryj nowe możliwości biznesowe w druku",
    casesCtaDesc:
      "Powiedz nam, co chcesz drukować, a dobierzemy odpowiednie rozwiązanie druku cyfrowego.",
    casesCtaButton: "Uzyskaj rozwiązanie druku",
    casesEmpty: "Brak scenariuszy zastosowań dla tego sprzętu.",
    casesIndustryNav: "Branże",
    backToTop: "Do góry",
    casesDetailTitle: "Wynik druku",
    casesVariantsIntro: "Typy do druku",
    casesVariantsMore: "itd.",
    casesVariantsHint: "Podaj materiał i ilość, aby otrzymać dopasowane rozwiązanie druku.",
    casesCardTagline: "Personalizacja",
    casesCardPitch: "Wysokoprecyzyjny druk kolorowy",
    casesPrintEffect: "Wynik druku",
    casesAppVideo: "Wideo zastosowania",
    casesVideoPlaceholder: "Wideo wkrótce",
    ...SCENE_KEYS_EN,
  },
};

const DETAIL_CLOSE = {
  zh: "关闭",
  en: "Close",
  de: "Schließen",
  pt: "Fechar",
  es: "Cerrar",
  fr: "Fermer",
  it: "Chiudi",
  hi: "बंद करें",
  ru: "Закрыть",
  ko: "닫기",
  ja: "閉じる",
  th: "ปิด",
  tr: "Kapat",
  vi: "Đóng",
  nl: "Sluiten",
  id: "Tutup",
  ar: "إغلاق",
  pl: "Zamknij",
};

Object.keys(caseTranslations).forEach((code) => {
  caseTranslations[code].casesDetailClose =
    DETAIL_CLOSE[code] || DETAIL_CLOSE.en;
});
